import { POST_PUBLISHED } from '@wix/communities-blog-universal/src/constants/ws-events';
import { fetchPost } from '../../actions/fetch-post';

export default {
  [POST_PUBLISHED]: ({ postId, slug }: { postId: string; slug?: string }) =>
    fetchPost(slug ?? postId),
};
